import { FundingType } from '@app-types/product';

import { CustomerAddress } from './delivery';
import { ErrorModalButton, TunnelErrorType } from './errors';

export enum PaymentMethodType {
    FREE = 'SANS_PAIEMENT',
    CREDIT_CARD = 'CB',
    PAYPAL = 'PAYPAL',
}

export type PaymentMethod = {
    type: PaymentMethodType;
};

export type CheckoutFundingType = FundingType & {
    paymentMethods: PaymentMethod[];
};

export type InitCartData = {
    cartId: number;
    quoteId: number;
    fundingMethods?: CheckoutFundingType[];
    address: CustomerAddress;
};

export type InitCartSuccess = InitCartData;

export type InitCartError = {
    errorCode: TunnelErrorType;
    cartData?: InitCartData;
    address?: CustomerAddress;
    title?: string;
    subtitle?: string;
    description?: string;
    primaryButton?: ErrorModalButton;
    secondaryButton?: ErrorModalButton;
};

export type InitCartResponse = InitCartSuccess | InitCartError;

export type VerifyAddressResponse = { address: CustomerAddress };

export type UserAdditionnalInfos = {
    civility: string;
};
